<template>
  <div class="applicantPersonalInfo">
    <review-card name="applicantPersonalInfoEdit" @edit="triggerModalOpening">
      <edit-applicant-personal-info v-if="showEditModal" @close="onModalClose" />

      <template #title>{{ t('title') }}</template>

      <div class="data">
        <text-object :label="t('firstNameLabel')">
          {{ primaryOwner.firstName }}
        </text-object>
        <text-object :label="t('lastNameLabel')">
          {{ primaryOwner.lastName }}
        </text-object>
        <text-object :label="t('emailLabel')">
          <div class="email">{{ primaryOwner.email }}</div>
        </text-object>
        <text-object :label="t('homeAddressLabel')">
          <div class="address">{{ address }}</div>
        </text-object>
        <text-object :label="t('primaryPhoneLabel')">
          {{ formatPhone(primaryOwner.primaryPhone) }}
        </text-object>
        <text-object :label="t('dobLabel')">
          {{ formatDate(primaryOwner.dateOfBirth) }}
        </text-object>
        <text-object :label="t('residencyStatusLabel')">
          {{ residencyStatus }}
        </text-object>
        <text-object :label="t('howDidYouHearAboutUsLabel')">
          {{ howDidYouHearAboutUs }}
        </text-object>
        <text-object
          v-if="!!application._extension.uniqueLoanCode"
          :label="t('uniqueLoanCodeLabel')"
        >
          {{ application._extension.uniqueLoanCode }}
        </text-object>
        <text-object v-if="!!primaryOwner.additionalPhone" :label="t('additionalPhoneLabel')">
          {{ formatPhone(primaryOwner.additionalPhone) }}
        </text-object>
      </div>
    </review-card>
  </div>
</template>
<script>
import ReviewCard from '@/components/ReviewCard';
import TextObject from '@/components/TextObject';
import EditApplicantPersonalInfo from '@/views/application/ReviewSubmit/EditApplicantPersonalInfo';
import buildTranslators from '@/utils/build-translators';
import convertFormat from '@/utils/convert-datetime-format';
import { FRONTEND_DOB_FORMAT, BACKEND_FORMAT } from '@/constants/date-formats';
import phone from '@/filters/phone';

export default {
  name: 'applicant-personal-info',
  components: {
    ReviewCard,
    TextObject,
    EditApplicantPersonalInfo,
  },
  props: {
    application: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showEditModal: false,
    };
  },
  computed: {
    primaryOwner() {
      return this.application.owners[0];
    },
    address() {
      const owner = this.primaryOwner || {};

      const line1 = [owner.unitNumber, owner.streetNumber, owner.streetName, owner.streetType]
        .filter(Boolean)
        .join(' ');

      const line2 = [[owner.city, owner.state].filter(Boolean).join(', '), owner.postalCode]
        .filter(Boolean)
        .join(' ');

      return [line1, line2].filter(Boolean).join('\n');
    },
    residencyStatus() {
      return this.$t(
        `ownerInfo.residencyStatus.options.${this.primaryOwner._extension.residencyStatus}`,
      );
    },
    howDidYouHearAboutUs() {
      return this.$t(`ownerInfo.howDidYouHearAboutUs.options.${this.application.hearAboutUs}`);
    },
  },
  methods: {
    formatPhone: phone,
    triggerModalOpening() {
      this.showEditModal = true;
      document.documentElement.style.overflow = 'hidden';
    },
    onModalClose() {
      this.showEditModal = false;
      this.$emit('modalClose');
      document.documentElement.style.overflow = 'auto';
    },
    t(key, options) {
      return buildTranslators('reviewSubmit.card.applicantPersonalInfo').t(key, options);
    },
    formatDate(dateInBackendFormat) {
      return convertFormat(dateInBackendFormat, BACKEND_FORMAT, FRONTEND_DOB_FORMAT);
    },
  },
};
</script>
<style lang="sass" scoped>
.data
  display: grid
  grid-template-columns: repeat(2, minmax(0, 1fr))
  row-gap: $glass-spacing-4
  column-gap: $glass-spacing-3

  +mq($stego)
    grid-template-columns: repeat(3, minmax(0, 1fr))

.email
  word-break: break-all

.address
  white-space: pre-line
</style>
